import React from 'react';
import './App.scss';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from 'react-router-dom';

import AboutMe from './pages/AboutMe';
import Work from './pages/Work'
import Life from './pages/Life'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1><code>Chris Ko</code></h1>
      </header>
      <Router>
        <div>
          <nav>
            <ul>
              <li>
                <Link to='/home'>Home</Link>
              </li>
              <li>
                <Link to='/about'>About Me</Link>
              </li>
              <li>
                <Link to='/work'>Work</Link>
              </li>
              <li>
                <Link to='/life'>Life</Link>
              </li>
            </ul>
          </nav>

          <Switch>
            <Route path="/about">
              <AboutMe/>
            </Route>
            <Route path="/work">
              <Work/>
            </Route>
            <Route path="/life">
              <Life/>
            </Route>
          </Switch>
        </div>
      </Router>
    </div>
  );
}

export default App;
